import { TabConfig } from '../../Components/common/TabNavigation';
import { isGlobalAdminUser } from '../../utils/accessControl';

export function buildProfileTabConfig(): TabConfig[] {
    const tabs: TabConfig[] = [
        { key: 'Plants', label: 'Plants', route: '/plants' },
        { key: 'Profile', label: 'Users', route: '/users' },
    ];
    if (isGlobalAdminUser()) {
        tabs.push({ key: 'Securities', label: 'Securities', route: '/securities' });
    }
    return tabs;
}
